/* Reveal logic for the B2B sticky CTA.
 *
 * The bar starts tucked below the viewport (CSS) and slides up the moment the
 * watched element — by default the hero enquiry form — scrolls out of view. It
 * slides back down when that element returns, so the bar never competes with the
 * form it points at.
 *
 * Clicking it is handled elsewhere: the [data-b2b-scroll] delegate in
 * frido-b2b-form.js does the smooth scroll and focus.
 */
(function () {
  'use strict';

  function initBar(bar) {
    if (bar.dataset.b2bStickyReady === 'true') return;
    bar.dataset.b2bStickyReady = 'true';

    var selector = bar.getAttribute('data-sticky-watch');
    var watched = selector ? document.querySelector(selector) : null;

    /* No target to watch (or no observer support) — the CTA is the only way to
       convert on this page, so fail open and leave it visible. */
    if (!watched || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
      /* The negative top margin trips the observer ~160px of scroll before the
         watched element fully clears the top, so the bar arrives a touch early. */
    }, { threshold: 0, rootMargin: '-160px 0px 0px 0px' });

    observer.observe(watched);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-b2b-sticky]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
